import { Box, styled } from '@mui/material'

export const StyledWidgetWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  minWidth: 0,
  overflow: 'hidden',
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(1.5),
  borderRadius: theme.spacing(0.5),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2), // padding for md and up
  },
}))
